import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
    // License
    {
        path: '/license/',
        name: 'List License',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.l1.read) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "license" */ '@/router/views/license')
    },

    {
        path: '/license/fleet/import/driver',
        name: 'License Fleet Import Driver',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/license/importDriverDoc')
    },

    {
        path: '/license/fleet/import/fleet',
        name: 'License Fleet Import Fleet',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "master" */ '@/router/views/license/importVehicleDoc')
    },

    // License Setting
    {
        path: '/license/licensesetting/',
        name: 'License Setting',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.l1.read) {
                    next();
                } else {
                    next({ name: "List License" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "license" */ '@/router/views/license/licensesetting')
    },
]